module.exports = __webpack_public_path__ + "Icono_ProductosMenu_126px.png";